import { DatabaseModel } from 'myfirebase'

// if you want to use cloud firestore
// import { FirestoreModel } from 'myfirebase' 

class Solarspot extends DatabaseModel {

    /**
     * Create new Solarspot Instance.
     * 
     * @param {object} ref
     */    
    constructor (ref) {
        super(ref)
    }

    /**
     * Define required properties.
     * 
     * @return array
     */
    required () {
        return []
    }
}

export default Solarspot;



// WEBPACK FOOTER //
// ./src/models/Solarspot.js